// Is a shared reaction picker (shared/_reaction_picker, emoji_picker_controller)
// open somewhere inside `root`? Poll-driven threads (peer-chat, reflection-feed)
// swap their whole innerHTML on a fingerprint change, which destroys an open
// picker mid-selection — so they check this first and leave the swap for the
// next poll. "Open" is either popover not carrying `hidden`.
export function hasOpenReactionPicker(root) {
    return !!root?.querySelector(".rxp-menu:not([hidden]), .rxp-full:not([hidden])")
}
